import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateKeyNotes } from './api/updateKeyNoteFn';
import { getKeyNoteKey } from './use-get-key-note';

import type { IKeyNoteData } from 'infrastructure/interfaces';
import type { ModuleType } from 'infrastructure/enums';

interface Props {
  module: ModuleType;
}

export const useUpdateKeyNote = ({ module }: Props) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: updateKeyNotes,
    onSuccess(data, vars) {
      const queryKey = getKeyNoteKey({
        module,
        patientGuid: vars.patientGuid,
        showExpired: vars.showExpired,
      });

      queryClient.setQueryData<IKeyNoteData[]>(queryKey, (dataCache) => {
        if (!dataCache) return dataCache;

        if (data) {
          const newData = dataCache.map((item) => {
            if (item.guid === data.guid) {
              return data;
            }
            return item;
          });

          return newData;
        }
      });
    },
  });
  return { updateKeyNote: mutate, isLoading };
};
